/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-04-21 11:33:22
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-05-21 15:59:48
 */

export default  {
  path: 'company',
  component: () => import(/* webpackChunkName: "company-list" */ '@/pages/company/CompanyList'),
  meta: {title:'商户管理',cate:'所有商户管理'},
  children: [
    {
      path: 'create',
      component: () => import(/* webpackChunkName: "company-create" */ '@/pages/company/CreateEdit'),
      meta: {title:'添加公司'},
    },
    {
      path: ':company_id/edit',
      component: () => import(/* webpackChunkName: "company-edit" */ '@/pages/company/CreateEdit'),
      meta: {title:'编辑公司'},
    },
    {
      path: ':company_id/view',
      component: () => import(/* webpackChunkName: "company-view" */ '@/pages/company/CreateEdit'),
      meta: {title:'查看公司'},
    }
  ]
}